import { render, staticRenderFns } from "./touristTips.vue?vue&type=template&id=255d2cf2&scoped=true"
import script from "./touristTips.vue?vue&type=script&lang=js"
export * from "./touristTips.vue?vue&type=script&lang=js"
import style0 from "./touristTips.vue?vue&type=style&index=0&id=255d2cf2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255d2cf2",
  null
  
)

export default component.exports